export enum Environment {
    Feat = "feat",
    Qa = "qa",
    Dev = "dev",
    Staging = "staging",
    PreProd = "preprod",
    Prod = "prod"
}

export const environmentResolver = (environment: string): Environment => {
    const resolver: Record<string, Environment | undefined> = {
        feat: Environment.Feat,
        qa: Environment.Qa,
        dev: Environment.Dev,
        staging: Environment.Staging,
        preprod: Environment.PreProd,
        prod: Environment.Prod
    };

    const resolvedEnv = resolver[environment];

    if (!resolvedEnv) {
        throw new Error(`Failed to resolve the specified environment: ${environment}`);
    }

    return resolvedEnv;
};
